import BaseModelAPI from '../BaseModelAPI';

export default class SenderStatus extends BaseModelAPI {
	static entity = 'senderstatus';
	static entityName = 'senderstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}